



































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { UnitPositionData, emptyPoint } from '@/api/heritageUnit/unitBase'
import { newGuid } from '@/configs/functions'

@Component({
  components: {}
})
export default class UnitPositionList extends Vue {
  public name = 'UnitPositionList'
  public modifyIndex: number = -1
  @Prop({ default: false })
  public viewModel: boolean = false
  @Prop({ default: '' })
  public centerName: string = ''
  @Prop({ default: 0 })
  public unitId: number = 0
  @Prop({ default: 0 })
  public listId: number = 0

  //由父级传入
  public dataList: UnitPositionData[] = []

  public openMap() {
    const data: { points: UnitPositionData[], unitId: number, mapTitle: string } = {
      points: this.dataList,
      unitId: this.unitId,
      mapTitle: this.centerName
    }
    window.eventBus.$emit('openUnitCoordPreview', data)
  }
  get filterSource(): any {
    let fs: any = []
    let types: number[] = []
    this.dataList.forEach((item: UnitPositionData, i: number) => {
      if (types.indexOf(item.PositionType) < 0) {
        fs.push({ text: item.TypeName, value: item.TypeName })
        types.push(item.PositionType)
      }
    })
    return fs
  }
  public filterMethod(value: string, row: UnitPositionData): boolean {
    return row.TypeName === value
  }
  get dataSource(): UnitPositionData[] {
    var f: UnitPositionData[] = this.dataList // Object.assign({}, this.dataList)
    return f.sort(this.sortMethod)
  }
  public sortMethod(a: UnitPositionData, b: UnitPositionData) {
    let typeA = a.PositionType
    let typeB = b.PositionType
    if (typeA == typeB) {
      let seqA = a.SubSequence
      let seqB = b.SubSequence
      return seqA > seqB ? 1 : seqA < seqB ? -1 : 0
    } else {
      return typeA > typeB ? 1 : -1
    }
  }
  public sortChanged(index: number) {
    let f = this.dataList[index]
    this.$set(this.dataList, index, f)
  }

  // dynamic component
  public $refs!: {
    // lngLatCtrl: UnitLngLat
  }
  public setData(data: UnitPositionData[]) {
    this.dataList = data
  }
  public getData() {
    return this.dataList
  }
  public addData() {
    this.modifyIndex = -1
    var newData = Object.assign({}, emptyPoint)
    const len = this.dataList.length
    let seq = 0
    if (len > 0) {
      seq = this.dataList[len - 1].SubSequence
    }
    newData.SubSequence = seq + 1
    this.showDataForm(newData)
  }
  public editData(index: number) {
    this.modifyIndex = index
    var item = this.dataList[index]
    var data = Object.assign({}, item)
    this.showDataForm(data)
  }
  public removData(index: number) {
    this.$confirm(`确定要删除吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.dataList.splice(index, 1)
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '操作已取消'
        })
      })
  }
  public updateData(data: UnitPositionData) {
    data.UnitId = this.unitId
    data.HeritageUnitId = this.listId
    if (this.modifyIndex >= 0) {
      this.$set(this.dataList, this.modifyIndex, data)
    } else {
      const defType = 1
      const defIndex = this.dataList.findIndex(
        (e: UnitPositionData) => e.PositionType == defType
      )
      if (data.PositionType == defType && defIndex > -1) {
        this.$confirm('单位坐标点只能设置一个，要覆盖原来的坐标吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$set(this.dataList, defIndex, data)
            this.$message({
              type: 'success',
              message: '已覆盖!'
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '取消覆盖'
            })
          })
      } else {
        this.dataList.push(data)
      }
    }
    this.modifyIndex = -1
  }
  //每次调用组件都生成一个guid，用来在上传完成后的回传
  public uploadGuid: string = ''
  public showDataForm(info: UnitPositionData) {
    if (this.uploadGuid == '') {
      this.uploadGuid = newGuid()
    }
    window.eventBus.$emit('openLngLatForm', {
      targetId: this.uploadGuid,
      data: info
    })
  }
  public closeDataForm() {
    console.log('closeLngLatForm')
  }
  public mounted() {
    window.eventBus.$on('submitLngLatForm', (info: any) => {
      if (info.targetId == this.uploadGuid) {
        this.updateData(info.data)
      }
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('submitLngLatForm')
  }
}
